
            const data = {"name":"location","data":{"width":"36","height":"36","viewBox":"0 0 36 36","data":"<path pid=\"0\" d=\"M8 17.52 28 6l-4.546 24-3.636-12.48H8Z\" _fill=\"#53284F\"/>","originalColors":[{"type":"fill","color":"#53284F"}],"stopColors":[]}}
        
                    module.exports = data
                    